import 'axios';
import './axiosInstance.js';
import './responses.js';
import './fetchFromApi.js';
import breachedAccount from './breachedAccount.js';
import pasteAccount from './pasteAccount.js';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * An object representing search results.
 *
 * @typedef {object} SearchResults
 * @property {(Breach[] | null)} breaches
 * @property {(Paste[] | null)} pastes
 */
/**
 * Fetches all breaches and all pastes associated with the provided account
 * (email address or username). Note that the remote API does not support
 * querying pastes by username (only email addresses), so in the event the
 * provided account is not a valid email address, only breach data is queried
 * and the "pastes" field of the resulting object will always be null. This is
 * exactly how searching via the current web interface behaves, which this
 * convenience method is designed to mimic.
 *
 * ***Warning:***
 *
 * As of January, 2019, `haveibeenpwned.com` has started blocking requests to
 * the `breachedaccount` endpoint when originating from within a browser (based
 * on the `User-Agent` field of the request headers). To use this function in a
 * browser, you will likely have to proxy your request through a server of your
 * own. The `baseUrl` option was added to facilitate this workaround.
 *
 * @param {string} account an email address or username
 * @param {object} [breachOptions] a configuration object
 * pertaining to breach queries
 * @param {string} [breachOptions.domain] a domain by which to filter the
 * results (default: all domains)
 * @param {boolean} [breachOptions.truncate] truncate the results to only
 * include the name of each breach (default: false)
 * @param {string} [breachOptions.baseUrl] a custom base URL for the
 * haveibeenpwned.com API endpoints (default: `https://haveibeenpwned.com/api`)
 * @param {string} [breachOptions.userAgent] a custom string to send as the
 * User-Agent field in the request headers (default: `hibp <version>`)
 * @returns {Promise<SearchResults>} a Promise which resolves to an object
 * containing a "breaches" key (which can be null or an array of breach objects)
 * and a "pastes" key (which can be null or an array of paste objects), or
 * rejects with an Error
 * @example
 * search('foo')
 *   .then(data => {
 *     if (data.breaches || data.pastes) {
 *       // ...
 *     } else {
 *       // ...
 *     }
 *   })
 *   .catch(err => {
 *     // ...
 *   });
 * @example
 * search('nobody@nowhere.com', { truncate: true })
 *   .then(data => {
 *     if (data.breaches || data.pastes) {
 *       // ...
 *     } else {
 *       // ...
 *     }
 *   })
 *   .catch(err => {
 *     // ...
 *   });
 *
 * @see https://haveibeenpwned.com/
 * @alias module:search
 */
var search = function search(account) {
    var breachOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var baseUrl = breachOptions.baseUrl, userAgent = breachOptions.userAgent;
    return Promise.all([breachedAccount(account, breachOptions),
        /^.+@.+$/.test(account) ? pasteAccount(account, {
            baseUrl: baseUrl,
            userAgent: userAgent
        }) : null]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2), breaches = _ref2[0], pastes = _ref2[1];
        return {
            breaches: breaches,
            pastes: pastes
        };
    });
};

export default search;
//# sourceMappingURL=search.js.map



//////////////////
// WEBPACK FOOTER
// ./~/hibp/es/search.js
// module id = ./node_modules/hibp/es/search.js
// module chunks = 2